import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import TuLenderScoreQuiz from "./TuLenderScoreQuiz";

ReactGA.initialize("G-HYZ0EMPMDN");

function App() {
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }, []);

  // Tracking functions
  const trackQuizStart = () => {
    ReactGA.event({
      category: "Quiz",
      action: "Started",
    });
  };

  const trackQuizComplete = (score) => {
    ReactGA.event({
      category: "Quiz",
      action: "Completed",
      label: `Score: ${score}`,
      value: score,
    });
  };

  const trackEmailSubmit = (score) => {
    ReactGA.event({
      category: "Lead",
      action: "Email Submitted",
      label: "Success",
      value: score,
    });
  };

  return (
    <TuLenderScoreQuiz
      onQuizStart={trackQuizStart}
      onQuizComplete={trackQuizComplete}
      onEmailSubmit={trackEmailSubmit}
    />
  );
}

export default App;
